import { Injectable } from '@angular/core';
// import { map, tap } from 'rxjs/operators';
import { AttachmentDto, AttachmentHandlerOptionsDto, DownloadableDocument, FacilityPatientResultsSearchDto, FacilityPatientResultsSearchResultsDto } from 'webcommon/shared';
import { FacilityPatientResultsRepository } from 'webcommon/webapi';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class FpResultsService {
  static readonly ajsFactoryName = 'FpResultsService';

  constructor(
    private facilityPatientResultsRepository: FacilityPatientResultsRepository,
  ) { }

  getResults(userQuery: FacilityPatientResultsSearchDto): Observable<FacilityPatientResultsSearchResultsDto[]> {
    return this.facilityPatientResultsRepository.getPatientResults(userQuery);
  }

  getAttachment(AttachmentUid: string): Observable<AttachmentDto> {
     return this.facilityPatientResultsRepository.getAttachment(AttachmentUid);
   }

   getAttachmentHandler(DocumentUid: string): Observable<AttachmentHandlerOptionsDto> {
    return this.facilityPatientResultsRepository.getAttachmentHandler(DocumentUid);
   }

   getAttachmentForDownload(attachmentId: string): Observable<DownloadableDocument> {
    return this.facilityPatientResultsRepository.getAttachmentForDownload(attachmentId);
   }

   getAttachmentStaticUrl(attachmentId: string): Observable<string> {
    return this.facilityPatientResultsRepository.getAttachmentStaticUrl(attachmentId);
   }

   getObservationOrderPdf(patientId: string, resultId: string): Observable<AttachmentDto> {
    return this.facilityPatientResultsRepository.getObservationOrderPdf(patientId, resultId);
   }
}
